import angular from 'angular'

import { ApiTax } from '@vend/types'
import { $q } from '../../ng-compat/imports'
import { EntityStore } from './entity-store'

/**
 * Stores information on the retailer's taxes.
 */
export class TaxesStore extends EntityStore<'taxes'> {
  constructor() {
    'ngInject'
    super({
      entityStoreName: 'taxes',
      syncDeleted: true,
    })
  }

  /**
   * Returns a tax which has only one tax rate, and that rate matches the
   * supplied rate id.
   *
   * @param  rateId
   *         The rate id to match against the tax's single rate.
   *
   * @return the matching tax.
   */
  public getTaxByRateId(rateId: string) {
    return this.all().then(taxes => {
      const tax = taxes.find(
        tax => tax.rates.length === 1 && tax.rates[0].id === rateId
      )
      if (tax !== undefined) {
        return tax
      } else {
        return $q.reject(`Could not find tax for rate ${rateId}`)
      }
    })
  }

  public get(id: string): Promise<ApiTax | undefined> {
    return new Promise((resolve, reject) => {
      super
        .get(id)
        .then(result => resolve(result))
        .catch(reason => reject(reason))
    })
  }
}

/**
 * Responsible for persisting storage of taxes in IndexedDB.
 *
 * @module taxesStore
 */
angular.module('webregister.factories').service('taxesStore', TaxesStore)
